module.exports = __webpack_public_path__ + "img/cart-promotion-badge.4103e37b.jpg";